import React from 'react';
import { Container } from '@pixi/react';
import { observer } from 'mobx-react-lite';

import PayTableButtons from './payTableButtons';
import PayTableStepRounds from './payTableStepRounds';
import { isMobile } from '../../../../../core/helpers/isMobile';

const PayTableFooter = observer(({ x, y, payTableStepCount }) => {
  return (
    <Container x={x} y={y} name='PayTableFooterContainer'>
      <PayTableButtons x={isMobile() ? 270 : 109} payTableStepCount={payTableStepCount} />
      {!isMobile() && <PayTableStepRounds x={87} y={38} payTableStepCount={payTableStepCount} />}
    </Container>
  );
});

export default PayTableFooter;
